interface NotFoundProps {
  // Overridable so callers rendering this for a reason other than "this
  // route doesn't exist yet" (e.g. RequireRole's access-denied fallback)
  // aren't stuck with copy that implies the page is simply unbuilt.
  message?: string;
}

export default function NotFound({
  message = "The route you requested is not yet implemented.",
}: NotFoundProps) {
  return (
    <div className="flex h-screen flex-col items-center justify-center text-center px-4">
      <h2 className="text-2xl font-semibold mb-2">404 — Page Not Found</h2>

      <p className="text-sm text-gray-600">{message}</p>
    </div>
  );
}
